import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { App, message } from 'antd';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Profile from './pages/Profile';
import ServiceProviders from './pages/ServiceProviders'; 
import DataPrivacy from './pages/DataPrivacy';
import ContactForm from './pages/ContactForm';
import Navbar from './pages/Navbar';
import UserProfile from './pages/UserProfile';
import SupportForm from './pages/SupportForm';
import AdminPage from './pages/AdminPage';
import SupportRequests from './pages/SupportRequests';
import MyRequests from './pages/MyRequests';
import SubmitTicket from './pages/SubmitTicket';
import PersonalInformation from './pages/PersonalInformation';
import ConnectedUsers from './pages/ConnectedUsers';
import Verifications from './pages/Verifications';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import ViewList from './pages/ViewList';
import AdminSupportRequests from './pages/AdminSupportRequests';
import ViewListProvider from './pages/ViewListProvider';
import VerificationsProvider from './pages/VerificationsProvider';
import AdminSupportProvider from './pages/AdminSupportProvider';
import ViewAllProvider from './pages/ViewAllProvider';
import AddCategoryProvider from './pages/AddCategoryProvider';
import Confirm from './pages/Confirm';
import AdminLogin from './pages/AdminLogin';
import AdminRegister from './pages/AdminRegister';
import SuperadminLogin from './pages/SuperadminLogin';
import SuperadminRegister from './pages/SuperadminRegister';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import UserqrSupportCases from './pages/UserqrSupportCases';
import useQrUserData from './pages/useQrUserData';

import SupportCases from './pages/SupportCases';





// Composant pour protéger les routes
const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch('/backend/check_auth.php', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include', // Inclure les cookies de session
        });

        const data = await response.json();

        if (response.ok && data.authenticated) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        setIsAuthenticated(false);
        message.error('Erreur lors de la vérification de l\'authentification.');
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return <div>Chargement...</div>; // Afficher un loader pendant la vérification
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function AppComponent() {
  return (
    <App>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/support" element={<div>Support Page</div>} />
          <Route path="/contact" element={<div>Contact Page</div>} />
          <Route path="/get-started" element={<div>Get Started Page</div>} />
          <Route path="/accessibility" element={<div>Accessibility Page</div>} />
          <Route path="/privacy" element={<div>Privacy Page</div>} />
          <Route path="/resources" element={<div>Resources Page</div>} />
          <Route path="/courses" element={<div>Courses Page</div>} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/confirm" element={<Confirm />} />
          <Route path="/AdminLogin" element={<AdminLogin />} />
          <Route path="/superadminlogin" element={<SuperadminLogin />} />
          <Route path="/superadminregister" element={<SuperadminRegister />} /> 
          <Route path="/AdminPage" element={<AdminPage />} /> 
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/UserqrSupportCases" element={<UserqrSupportCases />} />
          <Route path="/SupportCases" element={<SupportCases />} />
          <Route path="/useQrUserData" element={<useQrUserData />} />
          
         

          {/* Routes protégées */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          /><Route
            path="/DataPrivacy"
            element={
              <ProtectedRoute>
                <DataPrivacy />
              </ProtectedRoute>
            }
          />


          
         <Route
            path="/adminRegister"
            element={
              
                <AdminRegister />
              
            }
          />


           <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/serviceProviders"
            element={
              <ProtectedRoute>
                <ServiceProviders />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/ContactForm"
            element={
              <ProtectedRoute>
                <ContactForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Navbar"
            element={
              <ProtectedRoute>
                <Navbar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/UserProfile"
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SupportForm"
            element={
              <ProtectedRoute>
                <SupportForm />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/SupportRequests"
            element={
              <ProtectedRoute>
                <SupportRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MyRequests"
            element={
              <ProtectedRoute>
                <MyRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/SubmitTicket"
            element={
              
                <SubmitTicket />
              
            }
          />
          <Route
            path="/PersonalInformation"
            element={
              <ProtectedRoute>
                <PersonalInformation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ConnectedUsers"
            element={
              <ProtectedRoute>
                <ConnectedUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Verifications"
            element={
              
                <Verifications />
              
            }
          />
          <Route
            path="/SuperAdminDashboard"
            element={
             
                <SuperAdminDashboard />
              
            }
          />
          <Route
            path="/ViewList"
            element={
              
                <ViewList />
              
            }
          />
          <Route
            path="/AdminSupportRequests"
            element={
              <ProtectedRoute>
                <AdminSupportRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ViewListProvider"
            element={
              
                <ViewListProvider />
              
            }
          />
          <Route
            path="/VerificationsProvider"
            element={
             
                <VerificationsProvider />
              
            }
          />
          <Route
            path="/AdminSupportProvider"
            element={
              <ProtectedRoute>
                <AdminSupportProvider />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ViewAllProvider"
            element={
             
                <ViewAllProvider />
              
            }
          />
          <Route
            path="/AddCategoryProvider"
            element={
              <ProtectedRoute>
                <AddCategoryProvider />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </App>
  );
}

export default AppComponent;